import {
  RP_GAS_COMPOSITION_MODEL_LIST,
  RP_GAS_COMPOSITION_PAGINATION,
  RP_GAS_COMPOSITION_SEARCH,
} from "./actionType";


import moment from 'moment';

const initialState = {
  modelDeviceList: [],
  modelSearch: { GCDAILY_DATE: new Date() }, //moment(new Date().setDate(new Date().getDate() - 1)).format("YYYY-MM-DD"),
  pagination: { sizePerPage: 100, page: 1 }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case RP_GAS_COMPOSITION_MODEL_LIST:
      return { ...state, modelDeviceList: action.payload };
    case RP_GAS_COMPOSITION_SEARCH:
      return {
        ...state,
        modelSearch: action.payload,
      };
    case RP_GAS_COMPOSITION_PAGINATION:
      return { ...state, pagination: { sizePerPage: action.payload.sizePerPage, page: action.payload.page } };
    default:
      return state;
  }
};
